module.exports = __webpack_public_path__ + "static/media/categories-desktop.5a02b10d.jpg";